import { Injectable, ElementRef } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FocusInvalidService {

  constructor() { }

  selectInvalidInput(el: ElementRef) {
    let invalidControl = el.nativeElement.querySelector('.ng-invalid');

    if (invalidControl) {
      while (invalidControl.querySelector('.ng-invalid') !== null) {
        invalidControl = invalidControl.querySelector('.ng-invalid');
      }

      invalidControl.focus();
    }
  }

}
